import {Controller} from '@hotwired/stimulus';

const availableSliderControllers = [];

export default class extends Controller {

    static get targets() {
        return ['slider', 'thumbs'];
    }

    connect() {
        availableSliderControllers.push(this);
        const element = this.element;
        let slider = this.targets.find('slider');
        const useThumbs = this.targets.find('thumbs');
        if (!slider) {
            slider = element;
        }

        import('swiper').then(Swiper => {
            import('swiper/modules').then(SwiperModules => {
                const { Navigation, Pagination, Autoplay, Thumbs } = SwiperModules;
                const additionalConfig = slider.hasAttribute('data-swiper') ? JSON.parse(slider.getAttribute('data-swiper')) : {};
                // Config https://swiperjs.com/swiper-api
                const config = {
                    spaceBetween: 0,
                    modules: [Navigation, Pagination, Autoplay, Thumbs],
                    ...additionalConfig,
                };
                let thumbsSwiper;
                if (useThumbs) {
                    const additionalConfig2 = useThumbs.hasAttribute('data-swiper') ? JSON.parse(useThumbs.getAttribute('data-swiper')) : {};
                    const config2 = {
                        spaceBetween: 0,
                        modules: [Navigation, Thumbs],
                        ...additionalConfig2,
                    };
                    thumbsSwiper = new Swiper.default(useThumbs, config2);
                    config['thumbs']['swiper'] = thumbsSwiper;
                }

                if ('initBreakpoint' in config) {
                    if (window.innerWidth <= config['initBreakpoint']) {
                        this.swiper = new Swiper.default(slider, config);
                    }
                    window.addEventListener('resize', () => {
                        if (window.innerWidth <= config['initBreakpoint']) {
                            if (!this.swiper) {
                                this.swiper = new Swiper.default(slider, config);
                            }
                        } else if (this.swiper) {
                            const wrapper = this.swiper.wrapperEl;
                            this.swiper.destroy();
                            const parent = wrapper.parentNode;
                            while (wrapper.firstChild) {
                                parent.insertBefore(wrapper.firstChild, wrapper);
                            }
                            parent.removeChild(wrapper);
                            this.swiper = null;
                        }
                    })
                } else {
                    this.swiper = new Swiper.default(slider, config);
                }

                if (useThumbs) {
                    //this.swiper.control = thumbsSwiper;
                    //thumbsSwiper.control = this.swiper;
                }
            });
        });
    }
}
